<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="close"
    append-to-body
    title="消息详情"
  >
    <div class="dialog-content">
      {{ detail.id }}
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "newsDialog",
  props:['visible','detail'],
  data() {
    return {
    };
  },
  created() {
    
  },
  methods: {
    
    close(){
      this.$emit("close");
    }
  },
};
</script>
<style lang="less" scoped="scoped">
.dialog-content
{
  
}
</style>